export default __webpack_public_path__ + "static/media/app_image_2.351447a8.png";